import _ from 'lodash'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { getColor, colors, mapProps } from '../theme'
import Block from './Block'

export const Divider = styled(Block).attrs({ py: 1 })`
    position: relative;
    min-width: 100%;

    &::after {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        content: '';
        display: block;
        width: 100%;
        padding-top: .1875rem;
        padding-bottom: .1875rem;
        background-color: ${colors.clouds};
        border-radius: 1..3125rem;
    }

    ${mapProps({
        color(color) {
            return css`
                &::after {
                    background-color: ${getColor(color)};
                }
            `
        }
    })}
`

export default Divider



// WEBPACK FOOTER //
// ./src/styleguide/Divider.js